import { render, staticRenderFns } from "./ArchivedDeals.vue?vue&type=template&id=2fa5da0c&scoped=true&"
import script from "./ArchivedDeals.vue?vue&type=script&lang=js&"
export * from "./ArchivedDeals.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedDeals.vue?vue&type=style&index=0&id=2fa5da0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa5da0c",
  null
  
)

export default component.exports